<template>
    <div>
        <CInput
            label="Client Name"
            horizontal
            autocomplete="name"
            v-model="vendorData.client_name"
            invalidFeedback="Client name must be between 5 and 100 characters"
            :horizontal="{ label: 'col-sm-3', input: 'col-sm-9' }"
            disabled
        />

        <CInput
            label="Vendor Name"
            horizontal
            autocomplete="name"
            v-model="vendorData.vendor_name"
            invalidFeedback="Vendor name must be between 5 and 100 characters"
            :horizontal="{ label: 'col-sm-3', input: 'col-sm-9' }"
            disabled
        />

        <CInput
            v-if="type === 'unmappedAP'"
            label="Vendor Total Spend"
            horizontal
            type="text"
            v-model="localVendorTotalSpend"
            :horizontal="{ label: 'col-sm-3', input: 'col-sm-9' }"
            disabled
        />
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { storeData } from "../../../store";
import { GET_VENDOR_KEYWORD } from "../vendorQueries";

export default {
    name: "vendor_form",
    mixins: [validationMixin],
    props: {
        vendorName: {
            type: String,
            required: false,
            default: "",
        },
        vendorTotalSpend: {
            type: String,
            required: false,
            default: "",
        },
        type: {
            type: String,
            required: true,
        },
        clientName: {
            type: String,
            required: false,
            default: "",
        },
        clientId: {
            type: String,
            required: false,
            default: "",
        },
        vendorId: {
            type: Number,
            required: false,
            default: "",
        },
    },

    data() {
        return {
            vendorKeywords: {
                value: [],
                options: [],
            },
            localVendorTotalSpend: this.vendorTotalSpend,
            vendorData: {
                vendor_name: this.vendorName,
                client_id: this.clientId,
                client_name: this.clientName,
                vendor_id: this.vendorId,
            }
        };
    },

    watch: {
        vendorTotalSpend(newValue) {
            this.localVendorTotalSpend = newValue;
        },
        localVendorTotalSpend(newValue) {
            this.$emit('update:vendorTotalSpend', newValue);
        },
        vendorName(newValue) {
            this.vendorData.vendor_name = newValue;
        },
        clientId(newValue) {
            this.vendorData.client_id = newValue;
        },
        clientName(newValue) {
            this.vendorData.client_name = newValue;
        },
        vendorId(newValue) {
            this.vendorData.vendor_id = newValue;
        }
    },

    computed: {
        clientOptions() {
            return storeData.clientList.filter(client => client.value !== "All");
        },
        isSysAdmin() {
            return storeData.currentUserDetails.role.name === "sys_admin";
        },
        isGroupAdmin() {
            return storeData.currentUserDetails.role.name === "group_admin";
        },
        isEditMode() {
            return this.$route.path.includes("/vendors/edit");
        },
    },

    methods: {
        getVendorData() {
            return {
                ...this.vendorData,
                client_id: this.clientId // Ensure client_id is included in returned data
            };
        },
    },

};
</script>
